import HttpService from '@src/utility/httpService';
import { checkIsInternal } from '@src/utility/createStorage';
import { config } from '@uhg-abyss/web/tools/config';
import { FEATURE_FLAG_NAMES } from '@src/constants/featureFlags';
const _httpService = new HttpService();

if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}

export const fetchPSMSTinAssociationCheck = (tinInfo) => {
  const fetchData = async () => {
    try {
      const response: any = await _httpService.push(
        "extended-tins/external-psms-tins-search", { tin: tinInfo });
      if (response && response?.StatusCode === 200) {
        return response?.Data;
      } else {
        return response;
      }
    } catch {
      return null;
    }
  };
  return fetchData();
}

export const fetchPSMSFeatureFlag = () => {
  const fetchData = async () => {
    const apiDomainInternal: any = config('PNB_DOMAIN_INTERNAL');
    const pnbHttpService = new HttpService();
    pnbHttpService.setBaseURL(apiDomainInternal);
    try {
      const response: any = await pnbHttpService.push(
        "/pnb/feature-flags/getFeature", { name: FEATURE_FLAG_NAMES.PSMS });
      if (response && response?.statusCode === 200) {
        return response?.data?.flagValue || 'N';
      } else {
        return 'Y'; // default is yes to avoid any disruption in case of failure in fetching feature flag value
      }
    } catch {
      return 'Y'; // default is yes to avoid any disruption in case of failure in fetching feature flag value
    }
  };
  return fetchData();
}